import { render, staticRenderFns } from "./custom-search.vue?vue&type=template&id=c192e644&scoped=true"
import script from "./custom-search.vue?vue&type=script&lang=js"
export * from "./custom-search.vue?vue&type=script&lang=js"
import style0 from "./custom-search.vue?vue&type=style&index=0&id=c192e644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c192e644",
  null
  
)

export default component.exports